import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  white-space: pre-line;
`

export const Label = styled.div`
  color: var(--Foreground-Neutral-faded, #4d5874);

  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  text-align: center;
`
